import React, { useEffect, useState } from "react";

const YearDropdown = ({ date, handleDate, setIsOpen }) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i); // Last 50 years

  useEffect(() => {
    document
      .getElementById("selectedYear")!
      .scrollIntoView({ behavior: "smooth", block: "center" });
  }, []);

  return (
    <div className="customBar overflow-y-auto h-[300px] bg font-switzer text-center text-[12px] font-[400] text-primary-dark">
      <p className="p-2">Select Year</p>
      {years.map((year) => (
        <p
          key={year}
          onClick={() => {
            setIsOpen(false);
            handleDate(year);
          }}
          id={year === date ? "selectedYear" : "year"}
          className={`cursor-pointer py-1 hover:bg-[#D9D9D9] dark:hover:bg-[#696969] ${
            year === date
              ? "!bg-[#808080] dark:!bg-[#D9D9D9] text-[#FFFFFF] dark:text-[#191919]"
              : ""
          }`}
        >
          {year}
        </p>
      ))}
    </div>
  );
};

export default YearDropdown;
